import { setting } from './../../../setting';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
@Injectable()

export class HomeService {
  private appUrl = setting.apiBookingUrl;

	constructor(
                private _http: HttpClient,
              ) {
	}

  ratesInfo(infoAgencyConsult: any): Observable<any> {
    const url = `${this.appUrl}moebius-data`
    return this
                ._http
                .get<any>(
                   `${url}?escala=${infoAgencyConsult.channel}&locacion=${infoAgencyConsult.location_agency_id}&tipo=${infoAgencyConsult.type}&idioma=${infoAgencyConsult.language}`,
                  )
  }

 downloadDocument(data: any, infoAgencyConsult): void {
    const url = `${this.appUrl}moebius-data?escala=${infoAgencyConsult.channel}&locacion=${infoAgencyConsult.location_agency_id}&id=${data.archivo_id}&idioma=${infoAgencyConsult.language}`;
    window.open(url);
  }


}
